import { render } from "./CoachesPage.vue?vue&type=template&id=0295c120"
import script from "./CoachesPage.vue?vue&type=script&lang=js"
export * from "./CoachesPage.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__